// OBT F3-D — Tek bir varlık geçmiş kaydının gösterimi (append-only, salt-okunur).
import { useMemo } from 'react';
import { Calendar, Building2, FileText } from 'lucide-react';
import ReviewMediaGallery from '../review/ReviewMediaGallery';
import { readAssetPhoto } from './memoryApi';
import { WarrantyBadge, EventTypeBadge } from './MemoryBadges';
import { formatDate } from '../report/reportFormat';

export default function AssetRecordCard({ record, showPhotos = true }) {
  const photoIds = useMemo(
    () => (Array.isArray(record?.attachments) ? record.attachments.map((a) => a.photo_id) : []),
    [record]
  );
  const loadPhoto = useMemo(
    () => (photoId, opts) => readAssetPhoto(record.record_id, photoId, opts),
    [record.record_id]
  );

  return (
    <div className="rounded-md border border-gray-200 bg-white p-3">
      <div className="flex flex-wrap items-center gap-2">
        <EventTypeBadge type={record.event_type} />
        {record.event_date && (
          <span className="inline-flex items-center gap-1 text-xs text-gray-500">
            <Calendar className="h-3 w-3" aria-hidden="true" /> {formatDate(record.event_date)}
          </span>
        )}
        <WarrantyBadge status={record.warranty_status} />
      </div>
      <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-600">
        {record.company_name && (
          <span className="inline-flex items-center gap-1">
            <Building2 className="h-3 w-3 text-gray-400" aria-hidden="true" /> Firma: {record.company_name}
          </span>
        )}
        {record.tender_number && (
          <span className="inline-flex items-center gap-1">
            <FileText className="h-3 w-3 text-gray-400" aria-hidden="true" /> İhale: {record.tender_number}
          </span>
        )}
        {record.warranty_end_date && (
          <span>Garanti bitişi: {formatDate(record.warranty_end_date)}</span>
        )}
      </div>
      {record.description && (
        <p className="mt-2 text-sm text-gray-700">{record.description}</p>
      )}
      {record.notes && (
        <p className="mt-1 text-xs text-gray-500">Not: {record.notes}</p>
      )}
      {showPhotos && photoIds.length > 0 && (
        <div className="mt-2">
          <ReviewMediaGallery
            photoIds={photoIds}
            loadPhoto={loadPhoto}
            altPrefix="Varlık fotoğrafı"
            emptyText="Fotoğraf yok."
          />
        </div>
      )}
    </div>
  );
}
